import { create } from "zustand";

const useGenStore = create((set)=>({
    cartView:false,
    fonView:false,
    viewAdminDashboard:true,
    viewAdminDashboardLink:true,
    viewOrders: false,
    viewClearedOrders:false,
    viewAnalytics:false,
    viewEmails:false,
    orderPop:false,
    OrderStatusOnView:"",
    pageInView:"Welcome Back",
    orderOnView:null,
    totalUser:0,
    monthlySales:[],
    adminSideNav:false,
    totalEarnings:0,


    setCartView: (st)=>set({cartView:st}),
    setAdminSideNav: (an)=>set({adminSideNav:an}),
    setMonthlySales: (md)=>set({monthlySales:md}),
    setTotalEarnings: (e)=>set({totalEarnings:e}),
    setTotalUsers: (tu)=>set({totalUser:tu}),
    setOrderStatusOnView: (st)=>set({OrderStatusOnView:st}),
    setOrderOnView: (index)=>set({orderOnView:index}),
    setFonView: (fv)=>set({fonView:fv}),
    setOrderPopUp: (op)=>set({orderPop:op}),
    setViewAdminDashboard: (e)=>set({viewAdminDashboard:true,viewAdminDashboardLink:true,viewOrders:false,viewClearedOrders:false,viewAnalytics:false,viewEmails:false,pageInView:"Welcome Back"}),
    setViewOrders: (e)=>set({viewAdminDashboard:true,viewAdminDashboardLink:false,viewOrders:true,viewClearedOrders:false,viewAnalytics:false,viewEmails:false,pageInView:"Pending Orders"}),
    setViewClearedOrders: (e)=>set({viewAdminDashboard:false,viewAdminDashboardLink:false,viewOrders:false,viewClearedOrders:true,viewAnalytics:false,viewEmails:false,pageInView:"Cleared Orders"}),
    setviewAnalytics: (e)=>set({viewAdminDashboard:false,viewAdminDashboardLink:false,viewOrders:false,viewClearedOrders:false,viewAnalytics:true,viewEmails:false,pageInView:"Analytics"}),
    setviewEmails: (e)=>set({viewAdminDashboard:false,viewAdminDashboardLink:false,viewOrders:false,viewClearedOrders:false,viewAnalytics:false,viewEmails:true,pageInView:"Emails"})

}))

export default useGenStore;

